import { signOut } from "firebase/auth";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHook";

import Header from "../../components/Header/Header";
import ProfileCard from "../../components/ProfileCard/ProfileCard";
import { auth } from "../../firebase";
import { logout } from "../../features/authSlice";

const Profile = () => {
  const { user } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();

  const handleLogout = async () => {
    await signOut(auth);
    dispatch(logout());
  };

  return (
    <>
      <Header />
      {user && (
        <ProfileCard
          user={user}
          handleLogout={handleLogout}
        />
      )}
    </>
  );
};

export default Profile;
